import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { DocumentTypesComponent } from '../document-types/document-types.component';
import { IConfigurationEnclosure, IEnclosure } from '../../../shared/models/enclosure.model';
import { IEnclosureMinMax } from '../../../prisma-xs/models/prisma-xs.model';
import { EnclosureTabType } from '../../../shared/models/project.model';
import { IProduct } from '../../../shared/models/product.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-zoom-controls',
    templateUrl: './zoom-controls.component.html',
    styleUrls: ['./zoom-controls.component.scss'],
    standalone: false
})
export class ZoomControlsComponent {
  @Input() labels = false;
  @Input() covers = false;
  @Input() allProductsWithoutCover = false;
  @Input() noDevicesWithLabel: boolean;
  @Input() masslabeling = false;
  @Input() showCovers: boolean;
  @Input() showMasslabeling: boolean;
  @Input() showPdf: boolean;
  @Input() showEnclosurePdf: boolean;
  @Input() isInSldMode: boolean;
  @Input() zoomLevel: number;
  @Input() enclosure: IConfigurationEnclosure;
  @Input() enclosureMinMaxRange: Partial<IEnclosureMinMax>;
  @Input() mainContent: HTMLElement;
  @Input() products: IProduct[];
  @Input() selectedEnclosure: IEnclosure;
  @Input() switchboardContainerEl: HTMLElement;
  @Input() zoomControlsContainerEl: HTMLElement;
  @Input() tab: EnclosureTabType;

  @Output() zoomIn = new EventEmitter();
  @Output() zoomOut = new EventEmitter();
  @Output() zoomToFit = new EventEmitter();
  @Output() toggleLabels = new EventEmitter();
  @Output() toggleCovers = new EventEmitter<boolean>();
  @Output() toggleMasslabeling = new EventEmitter();
  @Output() dispositionPdf = new EventEmitter<{ fileName: string, showCovers: boolean }>();
  @Output() enclosurePdf = new EventEmitter<{ fileName: string, showCovers: boolean }>();

  @ViewChild('DispositionLayoutDescription') dispositionLayoutDescription: DocumentTypesComponent;
  @ViewChild('DispositionLayoutWCoversDescription') dispositionLayoutWCoversDescription: DocumentTypesComponent;
  @ViewChild('EnclosureLayoutDescription') enclosureLayoutDescription: DocumentTypesComponent;
  @ViewChild('EnclosureLayoutWCoverDescription') enclosureLayoutWCoverDescription: DocumentTypesComponent;

  zoomInGrid() {
    this.zoomIn.emit();
  }

  generateDispositionPdf() {
    this.dispositionPdf.emit({
      fileName: this.showCovers ? this.dispositionLayoutWCoversDescription.value : this.dispositionLayoutDescription.value,
      showCovers: this.showCovers
    });
  }

  generateEnclosurePdf() {
    this.enclosurePdf.emit({
      fileName: this.showCovers ? this.enclosureLayoutWCoverDescription.value : this.enclosureLayoutDescription.value,
      showCovers: this.showCovers
    });
  }

  onToggleLabels() {
    this.toggleLabels.emit();
  }

  onToggleCovers() {
    this.toggleCovers.emit(this.showCovers);
  }

  onToogleMasslabeling() {
    this.toggleMasslabeling.emit();
  }

  zoomOutGrid() {
    this.zoomOut.emit();
  }

  fitToWindow() {
    this.zoomToFit.emit();
  }

}
